module.exports = __webpack_public_path__ + "static/media/6.7e675bc7.png";